import * as React from 'react';

import {formEncodedApi} from 'nutshell-core/api';

import {Button} from 'shells/button/button';
import {MultiAddTextField} from 'shells/form/multi-add-textfield/multi-add-textfield';
import {PaperPlane} from 'shells/icon';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';
import {Header} from 'shells/typography/header';

import styles from './invite-users.module.css';

type UserInput = {
    email: string;
};

type State = {
    userInputs: UserInput[];
    isShowingSuccessState: boolean;
    error: string | null | undefined;
};

export class InviteUsers extends React.PureComponent<Record<any, any>, State> {
    constructor() {
        // @ts-expect-error
        super();
        this.state = {
            userInputs: [
                {
                    email: '',
                },
            ],
            error: null,
            isShowingSuccessState: false,
        };
    }

    render() {
        return (
            <div onClick={this.preventClose} className={styles.container}>
                {this.state.isShowingSuccessState ? (
                    <div className={styles['invite-container']}>
                        <Header>Invites sent!</Header>
                        <Body as='p'>
                            Your invitations have been sent and will be arriving shortly.
                        </Body>
                        <div className={styles['sent-icon']}>
                            <PaperPlane />
                        </div>
                        <div className='flex justify-center full-width'>
                            <Button
                                size='big'
                                variant='text-primary'
                                onClick={this.handleInviteMoreUsers}
                                noPadding={true}
                            >
                                Send more invites
                            </Button>
                        </div>
                        <div className={styles.divider} />
                        <div className='flex justify-center full-width'>
                            <Link variant='primary' href='/setup/user'>
                                Manage users & teams
                            </Link>
                        </div>
                    </div>
                ) : (
                    <div className={styles['invite-container']}>
                        <Header>Invite your team</Header>
                        <Body as='p'>
                            Invite the rest of your team to collaborate on leads and customers.
                            We’ll send them one email (no more!) with a link to log in to this
                            account. Licenses for your team will{' '}
                            {NutClientConfig.isTrial
                                ? 'be automatically assigned'
                                : 'need to be manually assigned by an administrator after creation'}
                            .
                        </Body>
                        <MultiAddTextField
                            items={this.state.userInputs}
                            onChange={(userInputs) => this.setState({userInputs})}
                            itemConfig={{
                                getValue: (item) => item.email,
                                setValue: (item, value) => ({...item, email: value}),
                                createNew: () => ({email: ''}),
                                getKey: (item, index) => `userInput-${index}`,
                            }}
                            placeholder='Email address'
                            addButtonText='Add another user'
                            hasError={Boolean(this.state.error)}
                            errorMessage={this.state.error || ''}
                            focusOnMount={true}
                            textFieldProps={{
                                type: 'email',
                                onEnter: this.handleSendInvites,
                                selectOnFocus: true,
                            }}
                            isDebouncedSave={false}
                        />
                    </div>
                )}
                {this.state.isShowingSuccessState ? undefined : (
                    <div className={styles['btn-invite']}>
                        <Button onClick={this.handleSendInvites} variant='save' size='big'>
                            Send invites
                        </Button>
                    </div>
                )}
            </div>
        );
    }

    handleSendInvites = () => {
        formEncodedApi
            .post('/setup/user/send-invites.json', {users: this.state.userInputs})
            .then(() => {
                this.setState({
                    userInputs: [
                        {
                            email: '',
                        },
                    ],
                    error: null,
                    isShowingSuccessState: true,
                });
                window.dispatchEvent(new CustomEvent('onboarding-step-completed'));
            })
            .catch((error) => {
                this.setState({
                    error: error.message
                        ? error.message
                        : 'An error occurred that prevented invites from being sent.',
                });
            });
    };

    handleInviteMoreUsers = () => {
        this.setState({isShowingSuccessState: false});
    };

    preventClose = (e: React.SyntheticEvent) => {
        e.stopPropagation();
    };
}
